import { createSlice } from '@reduxjs/toolkit';
import { getActiveRentList } from '../../reducers/active/activeThunks';
import { handleRequestThunk } from '../handleRequestThunk';
import { commonInitialState } from '../../../utils/common/commonInitialState';
const SLICE_NAME = 'activeRent';

export const activeRentSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getActiveRentList });
    },
});

export const selectActiveRent = (state) => state.activeRent.data;

export const activeRent = activeRentSlice.reducer;
